import * as actions from './actions';

export const initialState = {
    triggers: [],
    isRunTag: false,
    timestamp: 0
};

export const reducer = (state, action) => {
    if (action.type === actions.ADD_TRIGGER) {
        const { triggers } = state;

        return {
            ...state,
            triggers: triggers.concat(action.payload)
        };
    }

    if (action.type === actions.SKIP_TRIGGER) {
        const { triggers } = state;

        return {
            ...state,
            triggers: triggers.slice(1)
        };
    }

    if (action.type === actions.CHECK_TRIGGER) {
        const { triggers } = state;

        return {
            ...state,
            isRunTag: action.payload,
            timestamp: Date.now(),
            triggers: triggers.slice(1)
        };
    }

    return state;
};
